import React from 'react';
import './Footer.css';


function Footer() {
    return (
        <footer className='bg-navy'>
            <div className="container footercontainer">
                <div className="box text-white"><img className="mb-4 footerlogo" src="/assets/img/IFlogo-white-small.png" alt="" />
                    <p>© {new Date().getFullYear()} Irish Funds. <br className="d-none d-lg-block" />All rights reserved.</p>
                    <p><a href="mailto:info@irishfunds.ie">info@irishfunds.ie</a></p>
                </div>
                <div className="box text-white">
                    <h4 className="widget-title mb-3">Dublin Office</h4>
                    <p>Irish Funds Industry Association,<br/> Ashford House,<br/> 18-22 Tara Street,<br/> Dublin 2, <br/>D02 VX67</p>
                    <span><i className="fa-solid fa-phone-volume"></i> <a href="tel:+353 (0) 1 675 3200">+353 (0) 1 675 3200</a></span> 
                </div>
                <div className="box text-white">
                <h4 className="widget-title text-white mt-3">Belgium Office</h4>
                    <p>Avenue des Arts 44,<br/> 1040 Brussels,<br/> Belgium</p>
                    <span><i className="fa-solid fa-phone-volume"></i> <a href="tel:+32 2 882 5000">+32 2 882 5000</a></span>

         
                </div>
            </div>
        </footer>
    );
}

export default Footer;